/** @format */

import * as React from 'react';
//@ts-ignore
import { StyleSheet, View, Text, Platform, Image } from 'react-native';
import Images from '../images';
//@ts-ignore
import { observer } from 'mobx-react';
//@ts-ignore
import { JDDevice, JDText, JDImage, JDTouchable, JDJumping } from '@jdreact/jdreact-core-lib';
//@ts-ignore
import LinearGradient from '@jdreact/jdreact-core-linear-gradient';
import store from '../services/goodsContrastPageStore/store';
import { ITransformTopVo } from '../services/goodsContrastPageStore/domain';
import PropTypes from 'prop-types';
//埋点
import { logClick, ContrastPhoto, ContrastWord, ContrastClose, ContrastPlus } from '../mta/MtaService';
import { openapp } from '../utils/openapp';

const { getRpx, getFontSize } = JDDevice;
const styles = StyleSheet.create({
  wrap: {
    flexDirection: 'row',
    alignItems: 'center',
    // minWidth: getRpx(750),
    height: getRpx(334),
    paddingLeft: getRpx(25),
  },
  goodsBg: {
    width: getRpx(340),
    height: getRpx(320),
    position: 'absolute',
    top: -getRpx(16),
    left: -getRpx(20),
    zIndex: -1,
  },
  goodsItem: {
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    width: getRpx(300),
    height: getRpx(280),
    borderRadius: getRpx(12),
    marginLeft: getRpx(12),
    marginRight: getRpx(12),
    elevation: 4,
    shadowOffset: {
      width: 0,
      height: getRpx(4),
    },
    shadowColor: '#000000',
    shadowOpacity: 0.04,
    shadowRadius: getRpx(12),
    backgroundColor: '#ffffff',
    overflow: Platform.OS == 'android' ? 'hidden' : 'visible',
  },
  goodsFace: {
    width: getRpx(176),
    height: getRpx(176),
    marginBottom: getRpx(8),
  },
  goodsFaceImg: {
    width: getRpx(176),
    height: getRpx(176),
  },
  ImagesNum: {
    position: 'absolute',
    left: '50%',
    bottom: getRpx(11),
    marginLeft: -getRpx(52),
    width: getRpx(104),
    height: getRpx(32),
    borderRadius: getRpx(16),
    opacity: 0.5,
    backgroundColor: '#000000',
  },
  ImagesNumText: {
    textAlign: 'center',
    lineHeight: getRpx(32),
    fontSize: getRpx(26),
    color: '#ffffff',
  },
  goodsName: {
    flexDirection: 'row',
    alignItems: 'flex-end',
    width: getRpx(266),
    height: getRpx(70),
  },
  goodsText: {
    width: getRpx(266),
    height: getRpx(70),
    lineHeight: getRpx(35),
    fontWeight: 'bold',
    fontSize: getRpx(26),
    color: '#262626',
  },
  goodsJump: {
    position: 'absolute',
    bottom: 2,
    right: -getRpx(8),
    width: getRpx(8),
    height: getRpx(24),
    resizeMode: 'contain',
  },
  goodsDeleteIcon: {
    width: getRpx(30),
    height: getRpx(30),
    position: 'absolute',
    top: 0,
    right: 0,
  },
  goodsDelete: {
    width: getRpx(40),
    height: getRpx(40),
    position: 'absolute',
    top: 0,
    right: 0,
  },
  currentViewTag: {
    justifyContent: 'center',
    alignItems: 'center',
    minWidth: getRpx(60),
    height: getRpx(40),
    paddingLeft: getRpx(14),
    paddingRight: getRpx(14),
    borderTopLeftRadius: getRpx(12),
    borderTopRightRadius: getRpx(20),
    borderBottomRightRadius: getRpx(20),
    overflow: 'hidden',
  },
  currentViewTagBg: {
    width: '100%',
    height: getRpx(40),
    alignItems: 'center',
  },
  tagText: {
    width: '100%',
    height: getRpx(24),
    fontSize: getRpx(22),
    includeFontPadding: false,
    textAlignVertical: 'center',
    color: '#ffffff',
  },
  currentViewIcon: {
    width: getRpx(12),
    height: getRpx(6),
    resizeMode: 'contain',
  },
  currentView: {
    position: 'absolute',
    top: 0,
    left: 0,
  },
  vs: {
    position: 'absolute',
    top: getRpx(80),
    elevation: 10,
  },
  vsIcon: {
    width: getRpx(70),
    height: getRpx(70),
  },
  framePlacehodler: {
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    width: getRpx(300),
    height: getRpx(280),
    borderWidth: 1,
    borderRadius: getRpx(12),
    borderColor: '#D7D7D7',
    borderStyle: 'dashed',
  },
  textPlacehodler: {
    fontSize: getRpx(26),
    color: '#BFBFBF',
  },
  textBox: {
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignItems: 'center',
    height: getRpx(114),
  },
  addBtnIcon: {
    width: getRpx(56),
    height: getRpx(56),
  },
});
interface IStoreProps {
  store: {
    entrySku: string;
    cateId: string;
    maxCompareCount: number;
    contrastGoodsList: ITransformTopVo[];
    handleDeleteGoods: (T: number) => void;
    fadeInImageView: (T: string[]) => void;
  };
}
interface IProps extends IStoreProps {
  isReadOnly: boolean;
}
interface state {}
const transformStock = (state: number) => {
  switch (state) {
    case 1:
      return '可配货';
      break;
    case 2:
      return '采购中';
      break;
    case 3:
      return '无货';
      break;
    case 4:
      return '下架';
      break;
    default:
      //容灾降级处理
      return null;
  }
};
class ContrastGoods extends React.PureComponent<IProps, state> {
  static defaultProps = {
    isReadOnly: false,
  };
  static contextTypes = {
    router: (PropTypes as any).object,
  };
  constructor(props: IProps) {
    super(props);
  }
  handleDeleteGoods = (index: number) => {
    const { store } = this.props;
    logClick({
      event_id: ContrastClose,
      event_param: '',
      page_param: store.entrySku,
    });
    store.handleDeleteGoods(index);
  };
  handleShowImageView = (imageViewList: string[]) => {
    const { store, isReadOnly } = this.props;
    logClick({
      event_id: ContrastPhoto,
      event_param: '',
      page_param: store.entrySku,
    });
    //h5打开 图片预览功能
    // if (isReadOnly) return;
    store.fadeInImageView(imageViewList);
  };
  goAddContrastGoodsPage = () => {
    const {
      store: { entrySku },
    } = this.props;
    logClick({
      event_id: ContrastPlus,
      event_param: '',
      page_param: entrySku,
    });
    this.context.router.toAddGoodsContrast({ cateId: this.props.store.cateId });
  };
  jumpToGoodsDetail = (sku: string) => {
    const {
      store: { entrySku },
    } = this.props;
    logClick({
      event_id: ContrastWord,
      event_param: '',
      page_param: entrySku,
    });
    JDJumping.jumpToOpenapp(openapp.goodsDetail(sku));
  };
  render() {
    const { store, isReadOnly } = this.props;
    const { contrastGoodsList, maxCompareCount } = store;
    return (
      <View style={styles.wrap} key={'contrastgoods'}>
        {contrastGoodsList.map((goods, index) => {
          return (
            <View style={styles.goodsItem} key={goods.sku}>
              <View
                style={[
                  styles.goodsItem,
                  //h5生效
                  {
                    boxShadow: '0px 4px 20px 0px rgba(0,0,0,0.05)',
                  },
                ]}
              >
                <View style={styles.goodsFace} key={'contrastgoods_goodface'}>
                  <JDTouchable onPress={this.handleShowImageView.bind(this, goods.goodsImg)}>
                    <JDImage
                      style={styles.goodsFaceImg}
                      source={{
                        uri: `${goods.goodsImg[0]}`,
                      }}
                    ></JDImage>
                  </JDTouchable>
                  <View style={styles.ImagesNum}>
                    <JDText style={styles.ImagesNumText}>1/{goods.goodsImgCount}</JDText>
                  </View>
                </View>
                <View style={styles.goodsName}>
                  <JDTouchable onPress={this.jumpToGoodsDetail.bind(this, goods.sku)}>
                    <JDText style={styles.goodsText} type={'regular'} numberOfLines={2} ellipsizeMode={'tail'}>
                      {goods.goodsName}
                    </JDText>
                    <JDImage source={Images.contrast.goodsJumpArrow} style={styles.goodsJump}></JDImage>
                  </JDTouchable>
                </View>
                {!isReadOnly ? (
                  <JDTouchable onPress={this.handleDeleteGoods.bind(this, index)} style={styles.goodsDelete}>
                    <View style={styles.goodsDelete}>
                      <JDImage source={Images.common.deleteBtn} style={styles.goodsDeleteIcon}></JDImage>
                    </View>
                  </JDTouchable>
                ) : null}

                {/* index == 0 start */}
                {goods.goodsState != 0 ? (
                  <>
                    {Platform.OS != 'web' ? (
                      <View style={styles.currentView}>
                        <LinearGradient
                          colors={['rgba(255,165,10,1)', 'rgba(255,202,110,1)']}
                          start={{ x: 0, y: 0 }}
                          end={{ x: 1, y: 0 }}
                          style={styles.currentViewTag}
                        >
                          <JDText style={styles.tagText}>{transformStock(goods.goodsState)}</JDText>
                        </LinearGradient>
                        <JDImage source={Images.contrast.currentViewIcon} style={styles.currentViewIcon}></JDImage>
                      </View>
                    ) : null}
                  </>
                ) : null}
                {/* index == 0 end */}
              </View>
            </View>
          );
        })}
        {contrastGoodsList.length < maxCompareCount && !isReadOnly ? (
          <View style={styles.goodsItem}>
            <JDTouchable onPress={this.goAddContrastGoodsPage}>
              <View style={styles.framePlacehodler}>
                <View style={styles.textBox}>
                  <JDImage source={Images.contrast.placeholderBtn} style={styles.addBtnIcon}></JDImage>
                  <JDText style={styles.textPlacehodler}>添加对比的商品</JDText>
                </View>
              </View>
            </JDTouchable>
          </View>
        ) : null}
        {contrastGoodsList.map((goods, index) => {
          return (
            <>
              {index !== contrastGoodsList.length - 1 && contrastGoodsList.length >= maxCompareCount - 1 ? (
                <View
                  key={`vsicon${goods.sku}`}
                  style={[styles.vs, { left: getRpx(37 + (index + 1) * 300 + index * 24 - 24) }]}
                >
                  <JDImage style={styles.vsIcon} source={Images.contrast.vsIcon}></JDImage>
                </View>
              ) : null}
            </>
          );
        })}
      </View>
    );
  }
}
const ContrastGoodsComponent = observer(ContrastGoods);
const ContrastGoodsComponentWapper = (props: IProps) => <ContrastGoodsComponent {...props} store={store} />;
export default ContrastGoodsComponentWapper;
